export class ListOutputModel<T> {
  constructor(
    public readonly count: number,
    public readonly documents: T[]
  ) {}
}
